import { executeQuery } from "src/store";
import { baseService } from "src/store/base.store";
import { UserNotificationChannels } from "../types";
import { fcmTokenRepository } from "../repositories/fcm.repository";
import { userBroadcastChannelsRepository } from "../repositories/user-broadcast-channels.repository";
import { notificationHealthRepository } from "src/features/notification-health/notification-health.repository";

export const notificationChannelsService = baseService.injectEndpoints({
  endpoints: (build) => ({
    getUserNotificationChannels: build.query<UserNotificationChannels, string>({
      queryFn: (userId) =>
        executeQuery(async () => {
          const [[fcmTokens], subscribedChannels, notificationHealth] = await Promise.all([
            fcmTokenRepository.find({ where: { userId } }),
            userBroadcastChannelsRepository.findById(userId),
            notificationHealthRepository.findById(userId),
          ]);

          return { fcmTokens, subscribedChannels, notificationHealth };
        }),
    }),
  }),
});

export const {
  useGetUserNotificationChannelsQuery,
} = notificationChannelsService;
